module.exports = __webpack_public_path__ + "static/media/logo_texto.3a1c0e88.png";